import { render, staticRenderFns } from "./CardIeaAppMain.vue?vue&type=template&id=6cc3f742&scoped=true"
import script from "./CardIeaAppMain.vue?vue&type=script&lang=js"
export * from "./CardIeaAppMain.vue?vue&type=script&lang=js"
import style0 from "./CardIeaAppMain.vue?vue&type=style&index=0&id=6cc3f742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc3f742",
  null
  
)

export default component.exports